import { SplineElement } from '@elements/types';
import { proxy } from 'valtio';

interface ElementSelectionAreaState {
  selectedSplineElements: SplineElement[];
  selectedPointIds: string[];
}

export const elementSelectionAreaState = proxy<ElementSelectionAreaState>({
  selectedSplineElements: [],
  selectedPointIds: [],
});

export const setSelectedSplineElements = (elements: SplineElement[]) => {
  elementSelectionAreaState.selectedSplineElements = elements;
};

export const setSelectedPointIds = (pointIds: string[]) => {
  elementSelectionAreaState.selectedPointIds = pointIds;
};
